import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore
function FilterOption(props) {
  return /*#__PURE__*/_jsx("div", {});
}
FilterOption.defaultProps = {
  validateStatus: "default",
  adminOnly: false,
  removable: true,
  disabled: false
};
export default FilterOption;